import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

// import 'firebase/analytics'
import { firebaseConfig } from 'firebase/config'

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
  firebase.firestore().settings({ ignoreUndefinedProperties: true })
}

// firebase.analytics()

const auth = firebase.auth()
const db = firebase.firestore()
const storage = firebase.storage()
export const functions = firebase.functions()
export const fb = firebase
export const authPersistenceSession = firebase.auth.Auth.Persistence.SESSION
export const FirebaseTimestamp = firebase.firestore.Timestamp
export const GeoPoint = firebase.firestore.GeoPoint

if (process.env.REACT_APP_EMULATE) {
  auth.useEmulator('http://localhost:9099')
  storage.useEmulator('localhost', 9199)

  const firestoreSettings: any = {}

  firestoreSettings.host = 'localhost:8080'
  firestoreSettings.ssl = false

  if ((window as any).Cypress) {
    firestoreSettings.experimentalForceLongPolling = true
  }

  db.settings(firestoreSettings)

  console.log(`Using Firebase Auth emulator: localhost:9099`)
  console.log(`Using Cloud Storage emulator: localhost:9199`)
  console.log(`Using Firestore emulator: ${firestoreSettings.host}`)
}

export { auth, db, storage }

export const shopsRef = db.collection('shops')
export const staffsRef = db.collection('staffs')
export const storesRef = db.collection('stores')
export const usersRef = db.collection('users')

export type FirebaseUserCredential = firebase.auth.UserCredential
export type FirebaseCollectionRefType = firebase.firestore.CollectionReference
export type FirebaseDocRefType = firebase.firestore.DocumentReference
export type FirebaseTimestampType = firebase.firestore.Timestamp
export type FirebaseSnapshotType = firebase.firestore.QueryDocumentSnapshot
export type FirestoreDocumentSnapshot = firebase.firestore.DocumentSnapshot
export type FirebaseDocumentDataType = firebase.firestore.DocumentData
export type FirebaseDocChangeType = firebase.firestore.DocumentChange
export type FirebaseWriteBatch = firebase.firestore.WriteBatch
export type GeoPointType = firebase.firestore.GeoPoint
